import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { DiscResultsWebService, ExportToPrtgOptions, ExportToPrtgMapOptions } from 'discovery/services/discresults.web.service';
export { ExportToPrtgOptions, ExportToPrtgMapOptions } from 'discovery/services/discresults.web.service';
import { List } from 'DiscoveryEngine.TS/Utils';
import { GetSchedDiscResultsResultDto } from 'UvExplorerServer.Dtos.TS/Data';
import {
	DisplayDeviceGroupTreeDto, DisplayDeviceGroupContainerDto, DisplayDeviceGroupDto,
	DisplayDeviceListDto, GetDeviceGroupMembersResultDto, DeviceDto, InfoSetView,
	GetDeviceResultDto, ISetPortStateResultDto, IGetPortStateResultDto, PortStateDto
} from 'UvExplorerServer.Dtos.TS/Session';
import { PrtgSettingsSummaryDto } from 'UvExplorerServer.Dtos.TS/Session/PrtgSettingsSummaryDto';
import { PrtgGroupNodeDto } from 'UvExplorerServer.Dtos.TS/Session/PrtgGroupNodeDto';
import { PrtgMapDto } from 'UvExplorerServer.Dtos.TS/Session/PrtgMapDto';
import { ViewerDeviceGroupDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { ScheduledDiscoveryResultDto, RollupDto, SearchDeviceListDto } from 'UvExplorerServer.Dtos.TS/Discovery';
import { TopoMap } from 'topomap';
import { MessageService } from 'base';
import { LayoutSettings } from 'DiscoveryEngine.TS/Topology';
import { DiffResult } from 'DiscoveryEngine.TS/CommandLine';
import { Device } from 'DiscoveryEngine.TS/Core';


@Injectable()
export class DiscResultsService {

	private networkLoaded: Subject<any>;
	public onNetworkLoaded: Observable<any>;

	private deviceGroupTreeLoaded: Subject<DisplayDeviceGroupTreeDto>;
	public onDeviceGroupTreeLoaded: Observable<DisplayDeviceGroupTreeDto>;

	private deviceGroupTreeChanged: Subject<boolean>;
	public onDeviceGroupTreeChanged: Observable<boolean>;

	private topoMapLoaded: Subject<TopoMap>;
	public onTopoMapLoaded: Observable<TopoMap>;

	private deviceListLoaded: Subject<DisplayDeviceListDto>;
	public onDeviceListLoaded: Observable<DisplayDeviceListDto>;

	public loading: number;
	public deviceGroupTree: DisplayDeviceGroupTreeDto;
	public deviceList: DisplayDeviceListDto;
	public topoMap: TopoMap;

	private selectedDeviceGroup = new Subject<string>();
	public selectedDeviceGroupChanged = this.selectedDeviceGroup.asObservable();

	constructor(private discResultsWebService: DiscResultsWebService,
		private messageService: MessageService) {

		this.clear();

		this.networkLoaded = new Subject<any>();
		this.onNetworkLoaded = this.networkLoaded.asObservable();

		this.deviceGroupTreeLoaded = new Subject<DisplayDeviceGroupTreeDto>();
		this.onDeviceGroupTreeLoaded = this.deviceGroupTreeLoaded.asObservable();

		this.deviceGroupTreeChanged = new Subject<boolean>();
		this.onDeviceGroupTreeChanged = this.deviceGroupTreeChanged.asObservable();

		this.topoMapLoaded = new Subject<TopoMap>();
		this.onTopoMapLoaded = this.topoMapLoaded.asObservable();

		this.deviceListLoaded = new Subject<DisplayDeviceListDto>();
		this.onDeviceListLoaded = this.deviceListLoaded.asObservable();

		this.loading = 0;
		this.deviceGroupTree = null;
		this.deviceList = null;
		this.topoMap = null;
	}

	private clear(): void {
		this.topoMap = null;
		this.deviceGroupTree = null;
		this.deviceList = null;
	}

	public getSchedDiscResults(schedDiscGuid: string, dataSelector: string): Observable<List<ScheduledDiscoveryResultDto>> {
		let subject = new Subject<List<ScheduledDiscoveryResultDto>>();

		this.discResultsWebService.getSchedDiscResults(schedDiscGuid, dataSelector).subscribe(
			(result: GetSchedDiscResultsResultDto) => {
				subject.next(result.Results);
			},
			(error?) => {
				console.log(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public getSchedDiscResultByGuid(schedDiscRsltGuid: string, dataSelector: string): Observable<ScheduledDiscoveryResultDto> {
		return this.discResultsWebService.getSchedDiscResultByGuid(schedDiscRsltGuid, dataSelector);
	}

	public deleteSchedDiscResultByGuid(schedDiscRsltGuid: string): Observable<boolean> {
		return this.discResultsWebService.deleteSchedDiscResultByGuid(schedDiscRsltGuid);
	}

	public deleteResultsForSchedDisc(schedDiscGuid: string): Observable<boolean> {
		return this.discResultsWebService.deleteResultsForSchedDisc(schedDiscGuid);
	}

	public unload(sessionGuid: string): void {
		//this.clear();
		//this.unloadNetwork(sessionGuid);
	}

	public loadNetwork(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string): Observable<boolean> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: loadNetwork");
		}

		let subject = new Subject<boolean>();

		++this.loading;
		this.messageService.startWork();
		this.deviceGroupTree = null;
		this.deviceList = null;
		this.topoMap = null;
		this.discResultsWebService.loadNetwork(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid).subscribe(
				(result: boolean) => {
					this.discResultsWebService.getDeviceGroupTree(sessionGuid, netViewGuid).subscribe(
						(result: DisplayDeviceGroupTreeDto) => {
							this.deviceGroupTree = result;

							--this.loading;
							this.deviceGroupTreeLoaded.next(this.deviceGroupTree);
							this.deviceListLoaded.next(this.deviceList);
							this.topoMapLoaded.next(this.topoMap);
							this.networkLoaded.next(true);
							subject.next(true);
							this.messageService.endWork();
						},
						(error?) => {
							--this.loading;
							this.deviceGroupTreeLoaded.next(this.deviceGroupTree);
							this.deviceListLoaded.next(this.deviceList);
							this.topoMapLoaded.next(this.topoMap);
							this.networkLoaded.error(error);
							console.log(error);
							subject.error(error);
							this.messageService.endWork();
						});
				},
				(error?) => {
					--this.loading;
					this.deviceGroupTreeLoaded.next(this.deviceGroupTree);
					this.deviceListLoaded.next(this.deviceList);
					this.topoMapLoaded.next(this.topoMap);
					this.networkLoaded.error(error);
					console.log(error);
					subject.error(error);
					this.messageService.endWork();
				});

		return subject.asObservable();
	}

	private unloadNetwork(sessionGuid: string): Observable<boolean> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: unloadNetwork");
		}

		let subject = new Subject<boolean>();

		++this.loading;
		this.discResultsWebService.unloadNetwork(sessionGuid).subscribe(
			(result: boolean) => {
				--this.loading;
				this.deviceGroupTreeLoaded.next(this.deviceGroupTree);
				this.deviceListLoaded.next(this.deviceList);
				this.topoMapLoaded.next(this.topoMap);
				subject.next(true);
			},
			(error?) => {
				--this.loading;
				this.deviceGroupTreeLoaded.next(this.deviceGroupTree);
				this.deviceListLoaded.next(this.deviceList);
				this.topoMapLoaded.next(this.topoMap);
				console.log(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public loadDeviceGroup(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string): Observable<boolean> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: loadDeviceGroup");
		}

		let subject = new Subject<boolean>();

		++this.loading;
		this.messageService.startWork();
		this.deviceList = null;
		this.topoMap = null;

		this.discResultsWebService.getDeviceList(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, vdgGuid).subscribe(
				(result: DisplayDeviceListDto) => {
					this.deviceList = result;

					subject.next(true);
					this.deviceListLoaded.next(this.deviceList);
					this.messageService.endWork();
					--this.loading

					this.loadTopoMap(subject, sessionGuid, netViewGuid, agentGuid, schedDiscGuid, schedDiscRsltGuid, vdgGuid);

				},
				(error?) => {
					--this.loading;
					this.deviceListLoaded.next(this.deviceList);
					this.topoMapLoaded.next(this.topoMap);
					console.error(error);
					subject.error(error);
					this.messageService.endWork();
				});

		return subject.asObservable();
	}

	private loadTopoMap(subject, sessionGuid, netViewGuid, agentGuid, schedDiscGuid, schedDiscRsltGuid, vdgGuid) {
		this.discResultsWebService.getTopoMap(sessionGuid, netViewGuid, agentGuid, schedDiscGuid, schedDiscRsltGuid, vdgGuid).subscribe(
			(result: TopoMap) => {
				this.topoMap = result;
				this.topoMapLoaded.next(this.topoMap);

			},
			(error?) => {
				this.topoMapLoaded.next(this.topoMap);
				console.error(error);
				subject.error(error);
			});
	}

	public getFilteredDeviceList(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, source: string, primaryFilter: DeviceFilter,
		connectedFilter: DeviceFilter, requireSnmp: boolean, requireWmi: boolean, requireVim: boolean,
		requireSsh: boolean, requireConfig: boolean): Observable<DisplayDeviceListDto> {

		let subject = new Subject<DisplayDeviceListDto>();

		this.messageService.startWork();
		this.discResultsWebService.getFilteredDeviceList(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, source, primaryFilter, connectedFilter,
			requireSnmp, requireWmi, requireVim, requireSsh, requireConfig).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getDeviceGroupMembers(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: List<string>): Observable<GetDeviceGroupMembersResultDto> {

		let subject = new Subject<GetDeviceGroupMembersResultDto>();

		this.messageService.startWork();
		this.discResultsWebService.getDeviceGroupMembers(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getDeviceGroup(sessionGuid: string, netViewGuid: string, vdgGuid: string): Observable<ViewerDeviceGroupDto> {

		let subject = new Subject<ViewerDeviceGroupDto>();

		//this.messageService.startWork();
		this.discResultsWebService.getDeviceGroup(sessionGuid, netViewGuid, vdgGuid).subscribe(
			(result) => {
				subject.next(result);
				//this.messageService.endWork();
			},
			(error) => {
				console.log(error);
				subject.error(error);
				//this.messageService.endWork();
			});

		return subject.asObservable();
	}

	public getDevice(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, source: string, deviceGuids: List<string>,
		showBusy: boolean)
		: Observable<GetDeviceResultDto> {

		let subject = new Subject<GetDeviceResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.discResultsWebService.getDevice(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, source, deviceGuids).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}

					if (result.HasDevices) {
						result.Devices.ForEach((device: Device) => {
							device.DisplayNameSetting = result.DeviceDisplayNameSetting;
						});
					}

					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getDeviceView(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuid: string): Observable<DeviceDto> {

		let subject = new Subject<DeviceDto>();

		this.messageService.startWork();
		this.discResultsWebService.getDeviceView(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuid).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getDeviceTopoMap(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuid: string): Observable<TopoMap> {

		return this.discResultsWebService.getDeviceTopoMap(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, deviceGuid);
	}

	public getReportView(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, reportName: string): Observable<InfoSetView> {

		let subject = new Subject<InfoSetView>();

		this.messageService.startWork();
		this.discResultsWebService.getReportView(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, reportName).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getAdminReportView(sessionGuid: string, reportName: string): Observable<InfoSetView> {

		let subject = new Subject<InfoSetView>();

		this.messageService.startWork();
		this.discResultsWebService.getAdminReportView(sessionGuid, reportName).subscribe(
			(result) => {
				this.messageService.endWork();
				subject.next(result);
			},
			(error) => {
				this.messageService.endWork();
				console.log(error);
				subject.error(error);
			});

		return subject.asObservable();
	}


	public getLayer2Trace(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, source: string, deviceGuids: List<string>,
		showBusy: boolean): Observable<InfoSetView> {

		let subject = new Subject<InfoSetView>();

		this.messageService.startWork();
		this.discResultsWebService.getLayer2Trace(sessionGuid, netViewGuid, agentGuid, schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
			(result) => {
				this.messageService.endWork();
				subject.next(result);
			},
			(error) => {
				this.messageService.endWork();
				console.log(error);
				subject.error(error);
			});

		return subject.asObservable();
	}

	public setSelectedDeviceGroup(deviceGroupGuid: string) {
		this.selectedDeviceGroup.next(deviceGroupGuid);
	}

	public createDeviceGroup(sessionGuid: string, vdg: ViewerDeviceGroupDto, groupParentGuid: string, containerParentGuid: string,
		position: number): Observable<DisplayDeviceGroupDto> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: createDeviceGroup");
			//console.error("DiscResultsService.createDeviceGroup: Skipping.");
			//return new Observable<DisplayDeviceGroupDto>(observer => observer.next(null));
		}
		let parentGuid = null;
		if (containerParentGuid != null) {
			parentGuid = this.deviceGroupTree.FindContainerByGuid(containerParentGuid).VdgcGuid;
		}
		else if (groupParentGuid != null) {
			parentGuid = this.deviceGroupTree.FindGroupByGuid(groupParentGuid).VdgGuid;
		}

		let subject = new Subject<DisplayDeviceGroupDto>();
		if (parentGuid == null) {
			--this.loading;
			this.deviceGroupTreeChanged.next(true);
			let errorMessage = "The device group's container parent and group parent were either both null, or both not null";
			console.log(errorMessage);
			subject.error(errorMessage);
			return subject.asObservable();
		}

		++this.loading;
		//this.messageService.startWork();
		this.discResultsWebService.createDeviceGroup(sessionGuid, vdg, parentGuid, position).subscribe(
			(ddg: DisplayDeviceGroupDto) => {
				if (this.createDdgInTree(ddg, parentGuid)) {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.next(ddg);
					//this.messageService.endWork();
				}
				else {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.error("Could not insert device group into cached tree");
					//this.messageService.endWork();
				}
			},
			(error?) => {
				--this.loading;
				this.deviceGroupTreeChanged.next(true);
				console.log(error);
				subject.error(error);
				//this.messageService.endWork();
			});

		return subject.asObservable();
	}

	public updateDeviceGroup(sessionGuid: string, vdg: ViewerDeviceGroupDto): Observable<DisplayDeviceGroupDto> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: updateDeviceGroup");
			//console.error("DiscResultsService.updateDeviceGroup: Skipping.");
			//return new Observable<DisplayDeviceGroupDto>(observer => observer.next(null));
		}

		let subject = new Subject<DisplayDeviceGroupDto>();

		++this.loading;
		//this.messageService.startWork();
		this.discResultsWebService.updateDeviceGroup(sessionGuid, vdg).subscribe(
			(ddg: DisplayDeviceGroupDto) => {
				if (this.replaceDdgInTree(ddg)) {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.next(ddg);
					//this.messageService.endWork();
				}
				else {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.error("Could not update device group in cached tree");
					//this.messageService.endWork();
				}
			},
			(error?) => {
				--this.loading;
				this.deviceGroupTreeChanged.next(true);
				console.log(error);
				subject.error(error);
				//this.messageService.endWork();
			});

		return subject.asObservable();
	}

	public deleteDeviceGroup(sessionGuid: string, netViewGuid: string, guid: string, parentGuid: string): Observable<boolean> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: deleteDeviceGroup");
			//console.error("DiscResultsService.deleteDeviceGroup: Skipping.");
			//return new Observable<boolean>(observer => observer.next(false));
		}

		let subject = new Subject<boolean>();

		++this.loading;
		//this.messageService.startWork();
		this.discResultsWebService.deleteDeviceGroupByGuid(sessionGuid, netViewGuid, guid, parentGuid).subscribe(
			(result: boolean) => {
				if (this.removeDdgFromTree(guid, parentGuid)) {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.next(true);
					//this.messageService.endWork();
				}
				else {
					--this.loading;
					this.deviceGroupTreeChanged.next(true);
					subject.error("Could not delete device group from cached tree");
					//this.messageService.endWork();
				}
			},
			(error?) => {
				--this.loading;
				this.deviceGroupTreeChanged.next(true);
				console.log(error);
				subject.error(error);
				//this.messageService.endWork();
			});

		return subject.asObservable();
	}

	public deleteMasterDevice(sessionGuid: string, netViewGuid: string, deviceGuid: string): Observable<boolean> {

		if (this.loading) {
			console.warn("Reentrant call to DiscResultsService: deleteMasterDevice");
		}

		let subject = new Subject<boolean>();

		++this.loading;

		this.discResultsWebService.deleteMasterDeviceByGuid(sessionGuid, netViewGuid, deviceGuid).subscribe(
			(result: boolean) => {
			},
			(error?) => {
				--this.loading;
				console.log(error);
				subject.error(error);
				//this.messageService.endWork();
			});


		return subject.asObservable();
	}

	private createDdgInTree(newDdg: DisplayDeviceGroupDto, parentGuid: string): boolean {
		if (this.deviceGroupTree && this.deviceGroupTree.RootContainer) {
			return this._createDdgInTree(newDdg, parentGuid)
		}
		else {
			return false;
		}
	}

	private _createDdgInTree(newDdg: DisplayDeviceGroupDto, parentGuid: string): boolean {
		let parentContainer = this.deviceGroupTree.FindContainerByGuid(parentGuid);
		let parentGroup = this.deviceGroupTree.FindGroupByGuid(parentGuid);
		if (!!parentContainer) {
			parentContainer.Groups.Add(newDdg);
			return true;
		}
		else if (!!parentGroup) {
			parentGroup.ChildGroups.Add(newDdg);
			return true;
		}
		else {
			return false;
		}
	}

	private replaceDdgInTree(newDdg: DisplayDeviceGroupDto): boolean {
		if (this.deviceGroupTree && this.deviceGroupTree.RootContainer) {
			return this._replaceDdgInTree(newDdg);
		}
		else {
			return false;
		}
	}

	private _replaceDdgInTree(newDdg: DisplayDeviceGroupDto): boolean {
		let oldDdg = this.deviceGroupTree.FindGroupByGuid(newDdg.VdgGuid);
		if (oldDdg) {
			oldDdg.Owner = newDdg.Owner;
			oldDdg.Name = newDdg.Name;
			oldDdg.DeviceCount = newDdg.DeviceCount;
			oldDdg.VdgGuid = newDdg.VdgGuid;
			oldDdg.VdgTagGuid = newDdg.VdgTagGuid;
			oldDdg.ChildGroups = newDdg.ChildGroups;

			return true;
		}
		return false;
	}

	private removeDdgFromTree(guid: string, parentGuid: string): boolean {
		if (this.deviceGroupTree && this.deviceGroupTree.RootContainer) {
			return this._removeDdgFromTree(guid, parentGuid);
		}
		else {
			return false;
		}
	}

	private _removeDdgFromTree(guid: string, parentGuid: string): boolean {
		let group = this.deviceGroupTree.FindGroupByGuid(guid);

		let parentContainer = this.deviceGroupTree.FindContainerByGuid(parentGuid);
		let parentGroup = this.deviceGroupTree.FindGroupByGuid(parentGuid);
		if (!!parentContainer && !!group) {
			for (let i = 0; i < parentContainer.Groups.Count; ++i) {
				if (parentContainer.Groups.Get(i).VdgGuid == guid) {
					parentContainer.Groups.RemoveAt(i);
					this._removeChildrenOfGroup(group);
					return true;
				}
			}
		}
		else if (!!parentGroup && !!group) {
			for (let i = 0; i < parentGroup.ChildGroups.Count; ++i) {
				if (parentGroup.ChildGroups.Get(i).VdgGuid == guid) {
					parentGroup.ChildGroups.RemoveAt(i);
					this._removeChildrenOfGroup(group);
					return true;
				}
			}
		}
		else {
			return false;
		}
	}

	private _removeChildrenOfGroup(ddg: DisplayDeviceGroupDto): void {
		for (let i = 0; i < ddg.ChildGroups.Count; ++i) {
			let childDdg: DisplayDeviceGroupDto = ddg.ChildGroups.Get(i);
			let childDdgGuid: string = childDdg.VdgGuid;
			if (childDdg.HasChildGroups) {
				this._removeChildrenOfGroup(childDdg);
			}
		}
		ddg.ChildGroups.Clear();
	}

	public exportTopoMap(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		type: string, includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean,
		sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean): Observable<Blob> {

		return this.discResultsWebService.exportTopoMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, type, includeDeviceLabels,
			includeDeviceProperties, includeLinkLabels, includeLinkProperties,
			sheetsAcross, sheetsDown, vsdxFormat);
	}

	public exportTopoMapToLucid(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		type: string, includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean,
		sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean): Observable<string> {

		return this.discResultsWebService.exportTopoMapToLucid(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, type, includeDeviceLabels,
			includeDeviceProperties, includeLinkLabels, includeLinkProperties,
			sheetsAcross, sheetsDown, vsdxFormat);
	}

	public runPrtgExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runPrtgExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public listPrtgSettings(netViewGuid: string): Observable<PrtgSettingsSummaryDto[]> {
		return this.discResultsWebService.listPrtgSettings(netViewGuid);
	}

	public listPrtgGroups(netViewGuid: string, prtgSettingsGuid: string): Observable<PrtgGroupNodeDto[]> {
		return this.discResultsWebService.listPrtgGroups(netViewGuid, prtgSettingsGuid);
	}

	public listPrtgMaps(netViewGuid: string, prtgSettingsGuid: string): Observable<PrtgMapDto[]> {
		return this.discResultsWebService.listPrtgMaps(netViewGuid, prtgSettingsGuid);
	}

	public exportToPrtgDataOnly(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		prtgSettingsGuid: string): Observable<boolean> {

		return this.discResultsWebService.exportToPrtgDataOnly(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, prtgSettingsGuid);
	}

	public exportToPrtg(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		prtgSettingsGuid: string, exportName: string,
		options: ExportToPrtgOptions): Observable<boolean> {

		return this.discResultsWebService.exportToPrtg(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, prtgSettingsGuid, exportName, options);
	}

	public exportToPrtgMap(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		prtgSettingsGuid: string, mapName: string,
		prtgTargetGroupId: string,
		options: ExportToPrtgMapOptions): Observable<boolean> {

		return this.discResultsWebService.exportToPrtgMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, prtgSettingsGuid, mapName, prtgTargetGroupId, options);
	}

	public runAssetPandaExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runAssetPandaExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public runHaloExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runHaloExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public runHuduExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runHuduExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public runITGlueExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runITGlueExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public runJiraExport(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string): Observable<boolean> {

		return this.discResultsWebService.runJiraExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid);
	}

	public rebuildMasterNetwork(sessionGuid: string, netViewGuid: string)
		: Observable<boolean> {
		return this.discResultsWebService.rebuildMasterNetwork(sessionGuid, netViewGuid);
	}

	public moveTopoMapNode(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		nodeId: number, newX: number, newY: number): Observable<boolean> {

		return this.discResultsWebService.moveTopoMapNode(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, nodeId, newX, newY);
	}

	public layoutMap(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		layoutSettings: LayoutSettings): Observable<boolean> {

		return this.discResultsWebService.layoutMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, layoutSettings);
	}

	public setMapRoot(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, vdgGuid: string,
		operation: string, nodeId: number): Observable<boolean> {

		return this.discResultsWebService.setMapRoot(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, operation, nodeId);
	}

	public exportDeviceData(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string): Observable<Blob> {

		return this.discResultsWebService.exportDeviceData(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid);
	}

	public diff(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string,
		leftText: string, rightText: string): Observable<DiffResult> {

		return this.discResultsWebService.diff(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, leftText, rightText);
	}

	public getIpMacSightings(sessionGuid: string, netViewGuid: string, agentGuid: string, schedDiscGuid: string,
		schedDiscRsltGuid: string, ipAddress: string, macAddress: string, addressType: AddressType): Observable<InfoSetView> {

		let subject = new Subject<InfoSetView>();

		this.messageService.startWork();
		this.discResultsWebService.getIpMacSightings(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, ipAddress, macAddress, addressType).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public searchMasterDevices(searchText: string, searchType: string, skip: number, limit: number): Observable<SearchDeviceListDto> {

		return this.discResultsWebService.searchMasterDevices(searchText, searchType, skip, limit);
	}

	public getMasterDeviceView(masterDeviceGuid: string): Observable<DeviceDto> {

		return this.discResultsWebService.getMasterDeviceView(masterDeviceGuid);
	}

	public getMasterDeviceTopoMap(masterDeviceGuid: string): Observable<TopoMap> {

		return this.discResultsWebService.getMasterDeviceTopoMap(masterDeviceGuid);
	}

	public deleteMasterDeviceConfigEntry(deviceGuid: string, configKey: string, lastTimestamp: string): Observable<boolean> {
		return this.discResultsWebService.deleteMasterDeviceConfig(deviceGuid, configKey, lastTimestamp);
	}

}

export enum AddressType {
	Ip,
	Mac,
}
